<template>
  <ul>
    <li
      v-for="image in images"
      :key="image.fileId"
      class="image"
    >
      <fb-img
        :fileId="image.fileId"
        :mimeType="image.mimeType"
        :mediaServiceId="mediaServiceId"
        size="raw"
        class="mt-4"
      />
    </li>
  </ul>
</template>
<script>
import FbImg from '@/components/atoms/FbImg'

export default {
  components: {
    FbImg,
  },

  props: {
    images: {
      type: Array,
      required: true,
    },
    targetServiceId: {
      type: String,
      required: false,
    },
  },

  computed: {
    mediaServiceId() {
      return this.targetServiceId || this.$serviceId
    },
  },
}
</script>
